import { useEffect, useMemo , useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty, forEach } from 'lodash';
import store from '../store/store';
import { updateRegistrationStepTopics, updateAEMJsonData, updateSpanish, updateUiLocaledata, updateLangSpanish } from '../store/aem';
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Icon } from "@vds/icons";
import Cookies from 'js-cookie';
import { Click_tracking, navLinkClick } from '../common/Analytics/GAWrapper';
import { decodeHTML } from '../utility/common';

const Header = () => {
  const urlForGlobalNavCSS = global.config.AEM_NAV_URL + "etc/designs/vzwcom/gnav20/core.min.css";
  const urlForGlobalNavJS = global.config.AEM_NAV_URL + "etc/designs/vzwcom/gnav20/corporate.js";
  const allNotifications = useSelector((state) => state.AdobeResources.allNotifications);
  const userDataFromStore = useSelector((state) => state.data);
  const userLanguage = localStorage.getItem("lng") && localStorage.getItem("lng") === 'es' ? 'es' : 'en';
  const [updatedCiamSignInURL, setupdatedCiamSignInURL] = useState('');
  const [showContactModal, setShowContactModal] = useState(false)
  const [headerPromo,setHeaderPromo] = useState({});
  const prevPage = localStorage.getItem("url");
  const pagePath = prevPage ? `${prevPage?.replace(/^\/+/, '')}` : "";
  useEffect(() => {
    if (window?.location?.search?.includes('utm_')) {
      const utmUrl = `${window?.location?.search?.substring(1)}`;
      localStorage.setItem('utmUrl', utmUrl);
      

      setupdatedCiamSignInURL(`${global.config.CIAM_SIGN_IN_URL}${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}${pagePath}?ciamLang=${userLanguage}&${utmUrl}`);
    } else {
      if (localStorage.getItem('utmUrl')) {
        setupdatedCiamSignInURL(`${global.config.CIAM_SIGN_IN_URL}${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}${pagePath}?ciamLang=${userLanguage}&${localStorage.getItem('utmUrl')}`);
      } else {
        setupdatedCiamSignInURL(`${global.config.CIAM_SIGN_IN_URL}${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}${pagePath}?ciamLang=${userLanguage}`);
      }
    }
  }, [location])

  useEffect(() => {
    const linkTag = document.createElement("link");
    linkTag.href = urlForGlobalNavCSS;
    linkTag.rel = "stylesheet";
    linkTag.type = "text/css";
    document.head.appendChild(linkTag);

    const script = document.createElement("script");
    script.src = urlForGlobalNavJS;
    script.async = false;
    document.head.appendChild(script);

    // Func to handle navigation click events for Analytics
    const handleHeaderNavListeners = (event) => {
      let targetElement = event.target;
      const tagName = targetElement.tagName.toLowerCase();
      if (targetElement && (tagName === 'a') && !isEmpty(targetElement.href) && targetElement.href.includes('http')) {
        const link_identifier = !isEmpty(targetElement.id) ? targetElement.id : (!isEmpty(targetElement.ariaLabel) ? targetElement.ariaLabel : (!isEmpty(targetElement.innerHTML) ? targetElement.innerHTML : ''));
        const link_text = !isEmpty(targetElement.innerText) ? (targetElement.innerText).replace(/[\n\t]/g, '') : (!isEmpty(targetElement.textContent) ? (targetElement.textContent).replace(/[\n\t]/g, '') : '');
        const link_url = !isEmpty(targetElement.href) ? targetElement.href : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_data: null });  // Clear the previous event_data object.
        window.dataLayer.push({
          "event": "click",
          "detailed_event": "Navigation Link Clicked",
          "event_data": {
            "identifier": link_identifier,
            "link_text": link_text,
            "link_url": link_url
          }
        });
        console.log("Navigation Link Clicked");
      }
    };

    const addHeaderNavListeners = () => {
      const primaryNavMenu = document.querySelectorAll('.gnav20-primary-menu');
      if (primaryNavMenu && primaryNavMenu.length > 0) {
        primaryNavMenu.forEach(primaryNavMenuElement => {
          primaryNavMenuElement.addEventListener('click', handleHeaderNavListeners);
          primaryNavMenuElement.addEventListener('touchstart', handleHeaderNavListeners);
        });
      } else {
        setTimeout(addHeaderNavListeners, 1000);
      }
    };
    addHeaderNavListeners();
  }, []);
  //Signin listener starts

  useEffect(() => {
    const handleSignInListeners = (event) => {
      let targetElement = event.target;
      const tagName = targetElement.tagName.toLowerCase();
      console.log("clicked sign in");
      if (targetElement && (tagName === 'a') && !isEmpty(targetElement.href) && targetElement.href.includes('http')) {
        document.cookie = `firstTimeLogin=true;domain=${global.config.APP_COOKIE_DOMAIN};path=/`
        localStorage.removeItem('utmUrl', utmUrl);
      }
    };

    const handleAiSearchButtonClick = (event) => {
      event.preventDefault();
      navLinkClick('AI Search Button', 'AI Search Icon', '');
    }

    const addSignInListener = () => {
      const signInLinks = document.querySelectorAll('a[id="gnav20-account-link-id"]');
      if (signInLinks && signInLinks.length > 0) {
        signInLinks.forEach(signInLink => {
          signInLink.addEventListener('click', handleSignInListeners);
          signInLink.addEventListener('touchstart', handleSignInListeners);
        });
      }
      else {
        setTimeout(addSignInListener, 1000);
      }
    };

    const addAiSearchButtonListeners = () => {
    const aiSearchButton = document.querySelector(".gnav20 .gnav20-search-icon-vsbdr");
    if (aiSearchButton && aiSearchButton.length > 0) {
      forEach(aiSearchButton, (aiSearchButtonElement, index) => {
        aiSearchButton[index].addEventListener('click', handleAiSearchButtonClick);
      });
    }else {
      setTimeout(addAiSearchButtonListeners, 1000);
    }
  }

    addAiSearchButtonListeners();
    addSignInListener();
}, []);
  //Signin listener ends

  const openSupportModal = () => {
    //alert("add Support Modal Functionality here");
    setShowContactModal(true)
    document.getElementById('gnav20-closex').click();
   }
  const addSupportNavListners = () => {
    const supportLink = document.querySelectorAll(".gnav20 .gnav20-vsbdr-support");
    if(supportLink && supportLink.length > 0){
         for (i = 0; i < supportLink.length; i++) {
           supportLink[i].addEventListener("click", openSupportModal);
         }
      }else{
        setTimeout(addSupportNavListners, 1000)
      }
  }
  
    // const showHideHeaderPromoRibbon = (showPromo, promoText, datePlaceHolderTimeStamp) => {
    //   const headerPromoDiv = document.querySelector('.gnav20-promo') ?? null;
    //   const headerPromoDivText = document.querySelector('.gnav20-promo-text') ?? null;
    //   const currentTime = new Date().getTime() / 1000; // Get Current time in seconds since Epoch
    //   headerPromoDiv.style.display = 'none';
  
    //   if (showPromo === "true") {
    //     if(headerPromoDivText) headerPromoDivText.innerHTML = promoText;
    //     headerPromoDiv ? headerPromoDiv.style.display = '' : null;
    //     if(headerPromoDivText) headerPromoDivText.innerHTML = decodeHTML(promoText);
    //    const element =  document.querySelector('.gnav20-promotext')
    //    if(element){
    //     element.classList.add("opacityOne")
    //    }
        
    //   }      
    // };

  // useEffect(()=>{
  //   if(allNotifications){
  //     if (userLanguage && userLanguage === 'es' && allNotifications['es']) {
  //       setHeaderPromo(allNotifications['es']?.Header_Promo);
  //     } else if (allNotifications['en']) {
  //       setHeaderPromo(allNotifications['en']?.Header_Promo);
  //     }
  //   }
  // },[allNotifications]);

    
  // useEffect(() => {
  //   const addHeaderPromoRibbon = () => {
  //     const headerPromoDiv = document.getElementsByClassName('gnav20-promo');
  //     if (!isEmpty(headerPromoDiv) && headerPromoDiv[0]) {
  //       if (!isEmpty(headerPromo)) {
  //          headerPromoDiv[0].style.display = 'none';
  //          showHideHeaderPromoRibbon(headerPromo?.showPromo, headerPromo?.promoText, headerPromo?.datePlaceHolderTimeStamp);
  //       }
  //     } else {
  //         setTimeout(addHeaderPromoRibbon, 1000);
  //     }
  //   };

  //   addHeaderPromoRibbon();
  //   }, [headerPromo]);

  useEffect(() => {
    const updateHeaderSignIn = () => {
      // Load Custom Notifications Msgs frm AEM
      const signInLinks = document.querySelectorAll('a[id="gnav20-account-link-id"]');
      if(signInLinks && signInLinks.length > 0) {
        const signInLink = Array.from(signInLinks).find(
          link => link.getAttribute('aria-label') === "Sign in" || link.getAttribute('aria-label') === "Ingresar" 
        );
        if(signInLink) {
          signInLink.href = updatedCiamSignInURL;
        }
      }      
    };

    window.gnav20Ready = () => {
      updateHeaderSignIn();
    }
  }, [userLanguage, updatedCiamSignInURL]);

  useEffect(() => {
    const handleBodyClicker = (event) => {
      const learningButton = event.target.closest("#gnav20-Learning-L1, #gnav20-Learning-L1-mobile, #gnav20-Aprendizaje-L1, #gnav20-Aprendizaje-L1-mobile");
      if (learningButton) {
        Click_tracking("Learning", "Learning on the navigation header");
        event.stopImmediatePropagation(); // Prevent further propagation of the event
      }
    };
  
    // Attach the event listener
    document.body.addEventListener("pointerdown", handleBodyClicker);
  
    // Cleanup the listener on unmount
    return () => {
      document.body.removeEventListener("pointerdown", handleBodyClicker);
    };
  }, [window.innerWidth]); // Dependency on viewport width

  return (
  <>
    <div id="vz-gh20"></div>
    <Modal
    opened={showContactModal}
    surface="light"
    fullScreenDialog={false}
    disableAnimation={false}
    disableOutsideClick={false}
    ariaLabel="Testing Modal"
    closeButton={<span tabIndex={'0'} onKeyUp={e => { if (e.key == "Enter" || e.key == "Space")
     { setShowContactModal(false); } }} onClick={() => setShowContactModal(false)} className='modalIcon'><Icon
      name="close"
      size="medium"
      color="#000000"
    />
    </span>
    }
  >
    <ModalBody>
      <h2 tabIndex={'0'} className='contactTitle'>"Need help with your account?"</h2>
      <br />
    </ModalBody>
    <ModalFooter
      buttonData={{
        primary: {
          width: '100%',
          children: 'Email',
          onClick: () => { window.location.assign("mailto:xyz@test.com"); },
        },
        close: {
          width: '100%',
          children: 'Call 800.916.4351',
          onClick: () => {
            setShowContactModal(false);
            window.location.href = "tel:+12244404633";
          },
        },
      }}
    />
  </Modal>
</>
  );
};

export default Header;
